
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Profile',
  props: {
    name: String,
    hasActions: Boolean,
  },
  emits: ['logout'],
  setup(props, { emit }) {
    const showDropdown = ref<boolean>(false);

    const toggleDropdown = (show: boolean) => {
      showDropdown.value = show;
    };

    const onLogout = () => emit('logout');

    return { showDropdown, toggleDropdown, onLogout };
  },
});
